import { DateTime } from 'luxon';

export const formatToDateTime = (
  date?: Date | DateTime | string | null
): DateTime | undefined => {
  let formatted;

  if (typeof date === 'string') {
    formatted = DateTime.fromSQL(date);
  }
  if (date instanceof DateTime) {
    formatted = date;
  }
  if (date instanceof Date) {
    formatted = DateTime.fromJSDate(date);
  }

  return formatted;
};

export const getSelectedDay = (
  currentSleectedDay?: Date | DateTime | string | null,
  initialFocusedDate?: Date,
  maxDate?: Date | DateTime | string
) => {
  const formattedMaxDate = formatToDateTime(maxDate);
  const isMaxDateLowerThanToday =
    formattedMaxDate && formattedMaxDate.toMillis() < DateTime.now().toMillis();

  return (
    formatToDateTime(currentSleectedDay) ||
    // eslint-disable-next-line no-nested-ternary
    (initialFocusedDate
      ? formatToDateTime(initialFocusedDate)
      : isMaxDateLowerThanToday
        ? formattedMaxDate
        : DateTime.now())
  );
};
